// @flow strict
import * as React from 'react'

import type { Overdraft } from './types.js'
import styles from './OverdraftFeeCalculator.module.scss'

type Props = {|
  arranged: Overdraft,
  unarranged: Overdraft,
  rate: string,
  data: {|
    arranged: {
      APR19: {},
      APR29: {},
      APR39: {},
    },
    unarranged: {
      APR19: {},
      APR29: {},
      APR39: {},
    },
  |},
|}

function OverdraftFeeTotal({ arranged, unarranged, rate, data }: Props) {
  const { arranged: arrangedData, unarranged: unarrangedData } = data

  /**
   * In order to meet an urgent deadline, and to avoid
   * JavaScript's notoriously tricksy number handling,
   * cost data has been baked into this component.
   * Data was generated by the
   * service.overdraft-projected-charges service and
   * formatted, and is bundled with the component by
   * Webpack.
   * For future implementations, it is recommended to
   * create a public-facing API so that this data
   * always remains up-to-date. Until then, data can
   * be updated using the script in the scripts
   * directory in the workspace root.
   */

  const total = (
    parseFloat(arrangedData[rate][arranged.amount][arranged.days]) +
    parseFloat(unarrangedData[rate][unarranged.amount][unarranged.days])
  ).toFixed(2)

  return (
    <p className={styles.totalAmount}>
      &pound;
      <output name="totalCost" id="totalCost" aria-label="Total cost">
        {total}
      </output>
    </p>
  )
}

export default OverdraftFeeTotal
